<template>
	<div id="issue_apply" class="issue_apply p_background clearfix user-select">
		<h3 id="issue_title" class="all_title">发布应用</h3>
		<div id="container_box" class="container_box">
			<!--基本信息 start-->
			<section id="basic_message" class="basic_message partition_message">
				<h4 id="message_title" class="message_title"><i class="must_color">*</i>基本信息</h4>
				<div class="basic_container">
					<div class="container-fluid">
						<div class="row publick_form_box">

							<!--应用名称-->
							<section class="form_box">
								<label class="form_label" for=""><i class="must_color">*</i>应用名称：</label>
								<input type="text" id="issue_applyName" v-model="tCloudApp.appName" :disabled="hid" class="form-control form_control" maxlength="40" name="yymc" placeholder="40个字符以内，只允许中文数字" />
								<span class="tip_sub_text text_margin_left">(已签署合同和已上线应用不能修改应用名称)</span>
							</section>

							<!--应用英文名称-->
							<section class="form_box">
								<label class="form_label" for=""><i class="must_color">*</i>应用英文名称：</label>
								<input type="text" id="issue_applyEnName" v-model="tCloudApp.appEnName" :disabled="hid" class="form-control form_control" maxlength="60" name="ywyymc" placeholder="最多输入60个字符，只允许英文和数字" />
								<span class="tip_sub_text text_margin_left">(已签署合同和已上线应用不能修改应用英文名称)</span>
							</section>

							<!--桌面应用名称-->
							<section class="form_box">
								<label class="form_label" for=""><i class="must_color">*</i>显示桌面名称：</label>
								<input type="text" id="issue_applyZName" v-model="tCloudApp.viewName" :disabled="hid" class="form-control form_control" maxlength="6" name="zmmc" placeholder="显示在桌面的名称" />
							</section>

							<!--版本编号-->
							<section class="form_box">
								<label class="form_label" for=""><i class="must_color">*</i>版本编号：</label>
								<input type="text" id="issue_applyNumber" v-model="tCloudAppVersion.versionNo" :disabled="hidsubv" maxlength="20" placeholder="英文和数字以及“.”20字符以内" class="form-control form_control" />
							</section>

							<!--应用分类-->
							<section class="form_box">
								<label class="form_label" for=""><i class="must_color">*</i>应用分类：</label>
								<select v-model="tCloudApp.businessType" id="issue_select" class="form-control form_control" :disabled="hid">
									<option value="">请选择分类</option>
									<option v-for="option in appTypeOptions" v-bind:value="option.id">
										{{ option.dictionaryname }}
									</option>
								</select>
							</section>
							
							<!--应用范围-->
							<section class="form_box line_block" id="appLevel_box">
								<label class="form_label" for=""><i class="must_color">*</i>应用范围：</label>
								<div class="radio_box">
									<input type="radio" class="radio_input_y" id="app_level1" name="app_level" :disabled="hid" value="1" v-model="tCloudApp.appLevel"/>
									<label class="form_label radio_label" for="app_level1">校级</label>
								</div>
								<div class="radio_box">
									<input type="radio" class="radio_input_y " id="app_level2" name="app_level" :disabled="hid" value="2" v-model="tCloudApp.appLevel"/>
									<label class="form_label radio_label" for="app_level2">区级</label>
								</div>
							</section>
							
							<!--群体范围-->
							<section id="issue_checkbox" class="form_box line_block">
								<label class="form_label" for=""><i class="must_color">*</i>群体范围：</label>
								<div class="radio_box" v-for="(range,index) in appRange">
									<input type="checkbox" class="radio_input_f group_radio_range" :disabled="hid" :id="'rangid'+index" name="group_radio_range" :value="range.id" v-model="rangeCheck" />
									<label class="form_label radio_label" :for="'rangid'+index">{{range.dictionaryname}}</label>
								</div>
							</section>

							<!--增值服务-->
							<section id="issue_checkbox1" class="form_box line_block">
								<label class="form_label" for=""><i class="must_color">*</i>增值服务：</label>
								<div class="radio_box" v-for="(addservices,index) in appAddServices">
									<input type="checkbox" class="radio_input_f" :id="'addservicesid'+index" :disabled="hid" name="group_radio" :value="addservices.id" v-model="addservicesCheck" />
									<label class="form_label radio_label" :for="'addservicesid'+index">{{addservices.dictionaryname}}</label>
								</div>
							</section>

							<!--数据接口权限-->
							<section id="issue_checkbox2" class="form_box line_block">
								<label class="form_label" for=""><i class="must_color">*</i>数据接口权限：</label>
								<div class="radio_box" v-for="(interface,index) in appInterface">
									<input type="checkbox" class="radio_input_f" :id="'interfaceid'+index" :disabled="hid" name="group_radio" :value="interface.id" v-model="interfaceCheck" />
									<label class="form_label radio_label" :for="'interfaceid'+index">{{interface.dictionaryname}}</label>
								</div>
							</section>

							<!--部署类型-->
							<section id="deploy_type" class="form_box line_block">
								<label class="form_label" for=""><i class="must_color">*</i>部署类型：</label>
								<div class="radio_box" v-for="(deploytypech,index) in deployType">
									<input type="radio" class="radio_input_y" :id="'deploytypeid'+index" :disabled="hid" name="group_radio" :value="deploytypech.id" v-model="tCloudApp.deployType" @click="showVistUrl(deploytypech.id)"/>
									<label class="form_label radio_label" :for="'deploytypeid'+index">{{deploytypech.dictionaryname}}</label>
								</div>
							</section>
                            
                            <section id="deploy_visitUrl" class="form_box line_block" style="display: none;">
								<label class="form_label" for=""><i class="must_color">*</i>访问地址：</label>
								<div class="radio_box">
									<input type="text" id="issue_visitUrl" v-model="tCloudAppVersion.visitUrl"  class="form-control form_control" maxlength="500" name="visitUrl" placeholder="500个字符以内" />
								</div>
							</section>
							
							<!--支持客户端-->
							<section id="client_type" class="form_box line_block">
								<label class="form_label" for=""><i class="must_color">*</i>支持客户端：</label>
								<div class="radio_box" v-for="(clienttypech,index) in clientType">
									<input type="checkbox" class="radio_input_f" :id="'clienttypech'+index" :disabled="hid" name="group_radio_range" :value="clienttypech.id" v-model="clientTypeArray" />
									<label class="form_label radio_label" :for="'clienttypech'+index">{{clienttypech.dictionaryname}}</label>
								</div>
							</section>

							<!--窗口打开方式-->
							<section id="window_type" class="form_box line_block">
								<label for="" class="form_label">
									<span class="must_color">*</span>
									窗口打开方式：
								</label>
								<div class="radio_box">
									<input name="open_window" class="radio_input_y" type="radio" id="newwindow" :disabled="hid" value="1" v-model="tCloudAppVersion.openType" @change="newwindow()" />
									<label for="newwindow" class="radio_label form_label">新窗口</label>
								</div>
								<div class="radio_box">
									<input name="open_window" class="radio_input_y" type="radio" id="newinternal" :disabled="hid" value="2" v-model="tCloudAppVersion.openType" @change="newwindow1()" />
									<label for="newinternal" class="radio_label form_label">内置窗口</label>
								</div>
								<div class="window_size inline-block-3" v-if="tCloudAppVersion.openType == '2'">
									<section>
										<span>宽</span>
										<input type="text" class="form-control small_input" v-model="tCloudAppVersion.windowWidth" :disabled="hid" />
										<span>px;</span>
									</section>
									<section>
										<span>高</span>
										<input type="text" class="form-control small_input" v-model="tCloudAppVersion.windowHeight" :disabled="hid" />
										<span>px</span>
									</section>
								</div>
							</section>
							<!--应用介绍-->
							<section class="form_box">
								<label class="form_label" for=""><i class="must_color">*</i>应用介绍：</label>
								<textarea name="" id="issue_textarea" v-model="tCloudAppVersion.appComment" :disabled="hid" @change="valdata()" class="form-control form_textarea" rows="5" placeholder="简介(字符请控制在20到500个字)"></textarea>
							</section>

						</div>
					</div>
				</div>
			</section>
			<!--基本信息 end-->

			<!--web 安装包 与 版本更新说明 start-->
			<div class="container-fluid">
				<div class="row">
					<!--web安装包 start-->
					<div class="col-sm-6 partition_message" id="package" style="display: block;">
						<h4 class="message_title"><i class="must_color">*</i>应用镜像包</h4>
						<section class="install_box">
							<label class="file_text form_label">
	    					应用镜像包：
	    					</label>
							<div class="file_wrap inline-block pos-relative" :disabled="hidsubv">
								<form>
									<div class="file_box">
										<input type="file" id="batchFile" @change="uploadWeb($event)" :disabled="hidsubv" />
									</div>
									<i class="glyphicon ico_del" @click="delPackage" v-if="!hidsubv"></i>
									<span class="file_name text-space" data-toggle="tooltip" data-placement="bottom" :title="webfileorignalname">{{webfileorignalname}}</span>
								</form>
							</div>
							<div class="progress progress-striped active" style="display: none">
								<div id="progressBar" class="progress-bar progress-bar-info" role="progressbar" aria-valuemin="0" aria-valuenow="0" :disabled="hid" aria-valuemax="100" style="width: 0%">
								</div>
							</div>
						</section>
					</div>

					<!--web安装包 end-->
					<!--版本更新 start-->
					<div class="col-sm-6 partition_message" v-if="versioncontent">
						<h4 class="message_title"><i class="must_color">*</i>版本更新说明</h4>
						<section class="explain_box">
							<textarea name="" v-model="tCloudAppVersion.versionComment" class="form-control" :disabled="hidsubv" @change="valdata1()" rows="10" placeholder="简介(字符请控制在20到500个字)"></textarea>
						</section>
					</div>
					<!--版本更新 end-->
					
					<!--发布时间 start-->
					<section class="issue_time_box partition_message col-sm-12"  :class="{'col-sm-6':!versioncontent}">
						<h4 class="message_title"><i class="must_color">*</i>发布时间</h4>
						<div class="issue_time_container">
							<div class="container-fluid">
								<div class="row publick_form_box">
		
									<!--应用名称-->
									<section class="form_box">
										<label class="form_label" for="">发布时间：</label>
										<div class="issue_time_radio_box">
											<div class="issue_time_radio">
												<input type="radio" class="radio_input_y" :disabled="hidsubv" name="radio_issue_time" id="issue_time_radio" @click="openSub(1)" value="1" v-model="tCloudAppVersion.publishType" />
												<label class="form_label radio_label" for="issue_time_radio">审核后立即发布</label>
											</div>
											<div class="issue_time_radio">
												<input type="radio" class="radio_input_y" :disabled="hidsubv" name="radio_issue_time" id="issue_time_radio1" @click="openSub(2)" value="2" v-model="tCloudAppVersion.publishType" />
												<label class="form_label radio_label" for="issue_time_radio1">定时发布</label>
												<div id="issue_date_box" class="time_option" style="display: none;">
													<el-date-picker v-model="tCloudAppVersion.publishTime" type="datetime" placeholder="选择日期时间" :disabled="hidsubv">
													</el-date-picker>
												</div>
											</div>
											<div class="issue_time_radio">
												<input type="radio" class="radio_input_y" :disabled="hidsubv" name="radio_issue_time" id="issue_time_radio2" value="3" @click="openSub(3)" v-model="tCloudAppVersion.publishType" />
												<label class="form_label radio_label" for="issue_time_radio2">审核后手动确认</label>
											</div>
										</div>
									</section>
		
								</div>
							</div>
						</div>
					</section>
					<!--发布时间 end-->
				</div>
			</div>
			<!--web 安装包 与 版本更新说明 end-->
			
			<!--授权类型 start-->
			<section class="authorization_box partition_message">
				<h4 class="message_title"><i class="must_color">*</i>授权类型</h4>
				<div class="authorization_container">
					<div class="container-fluid">
						<div class="row publick_form_box">

							<section class="form_box line_block">
								<label class="form_label" for="">授权类型：</label>
								<div class="radio_box">
									<input type="radio" class="radio_input_y" id="radio_authorization1" name="radio_authorization" v-model="tCloudApp.authType" @click="authorizationBoxShow()" value="1" />
									<label class="form_label radio_label" for="radio_authorization1">公开发布</label>
								</div>
								<div class="radio_box">
									<input type="radio" class="radio_input_y " id="radio_authorization2" name="radio_authorization" v-model="tCloudApp.authType" @click="authorizationBoxShow()" value="2" />
									<label class="form_label radio_label" for="radio_authorization2">隐私发布</label>
								</div>
							</section>

							<section id="radio_authorization_form_box" class="form_box text-center" style="display: none;">
								<label for="" class="form_label">授权码</label>
								<input type="text" class="form-control form_control" readonly="readonly" name="" id="" value="" v-model="tCloudApp.authCode" placeholder="请输入授权码" />
								<i class="glyphicon icon_reload" @click="authorizationBoxShow()"></i>
								<p class="tip_sub_text hint_small_left">
									<small>(不在应用库中显示,通过搜索授权码显示)</small>
								</p>
							</section>

						</div>
					</div>
				</div>
			</section>
			<!--授权类型 end-->

			<!--图标素材 start-->
			<section class="material_icon_box partition_message">
				<h4 class="message_title"><i class="must_color">*</i>图标素材</h4>
				<div class="material_icon_container">
					<div class="container-fluid">
						<div class="row publick_form_box">
							<section class="col-sm-6">
								<span class="file_text">
		    					应用图标：
		    				</span>
								<div class="file_box" :style="{backgroundImage : 'url('+ fileImg + ')'}">
									<form id="subform" enctype="multipart/form-data" method="post" action="/zklccloud/uploadImages">
										<input type="file" name="file" id="uploadImage" :class="{'vis-hide': classVisFlag}" @change="uploadImage()" @click="disabledF" :disabled="hidsubv">
										<input type="hidden" name="type" value="2">
									</form>
								</div>
								<div class="tip_text">
									<p>要求：</p>
									<p>1.等边矩形</p>
									<p>2.PNG、JPG</p>
									<p>3.尺寸≥512px</p>
									<p>4.不超过1M</p>
								</div>
							</section>
							<section class="col-sm-6">
								<h5>更多尺寸：</h5>
								<div class="row more_content text-center">
									<a class="col-sm-6" :href="icon.filePath" v-for="icon in icolist" target="_blank">{{icon.viewSize}}*{{icon.viewSize}}</a>
								</div>
							</section>
						</div>
					</div>
				</div>
			</section>
			<!--图标素材 end-->

			<!--应用截图 start-->
			<section class="screenshot_box partition_message">
				<h4 class="message_title"><i class="must_color">*</i>应用截图</h4>
				<div class="screenshot_container">
					<div class="container-fluid">
						<div class="row publick_form_box">
							<p>
								<small class="tip_small_text">请上传2-5张图片,大于500px,格式PNG\JPG,2M以内大小</small>
							</p>
							<div class="img_box pos-relative" v-for="(path,index) in paths" v-show="path.length!=0" :disabled="hidsubv">
								<img v-bind:src="path" />
								<i class="glyphicon ico_del" @click="delImg(index)" v-if="!hidsubv"></i>
							</div>
							<div class="file_box" v-show="paths.length<=4" :disabled="hidsubv">
								<form>
									<input type="file" name="file" id="addAppImage" @change="addAppImage($event)" :disabled="hidsubv" />
								</form>
							</div>
						</div>
					</div>
				</div>
			</section>
			<!--应用截图 end-->

			<!--资费 start-->
			<section class="expenses_box partition_message">
				<h4 class="message_title"><i class="must_color">*</i>资费</h4>
				<div class="expenses_container">
					<div class="container-fluid">
						<div class="row publick_form_box">
							
							<!--<section class="add_operation clearfix">
								<section class="form_box col-lg-4 col-md-6 col-sm-12">
									<label class="width_auto" for="">单套价格：</label>
									<input type="text" class="form-control form_control addList_money" id="addList_money" v-model="addList.money" /> 人民币
								</section>
								
								<section class="form_box col-lg-4 col-md-6 col-sm-12">
									<label class="width_auto" for="">服务期限：</label>
									<input type="hidden" id="addList_timeLimit" class="addList_timeLimit" :value="addList.timeLimit" />
									<select class="form-control form_control" v-model="addList.timeLimit">
										<option disabled="disabled">请选择服务期限</option>
										<option value="1">1个月</option>
										<option value="12">1年</option>
										<option value="∞">无期限</option>
									</select>
								</section>
								<div class="line_block suit col-lg-4 col-md-6 col-sm-12 clearfix">
									<section>
										<span>套数：</span>
										<input type="text" class="form-control form_control addList_minNum" id="addList_minNum" v-model="addList.minNum" />
										<span>~</span>
										<input type="text" class="form-control form_control addList_maxNum" id="addList_maxNum" v-model="addList.maxNum" />
									</section>
									<div class="btn_box pull-right margin_l15">
										<button class="btn btn_border" id="addOperationBtn" @click="addOperation()">添加 +</button>
									</div>
								</div>
							</section>-->
							<div class="btn_box text-right">
								<button class="btn btn_border" id="addOperationBtn" :disabled="hidsubv" @click="addOperation()">添加 +</button>
							</div>
							<section class="add_list clearfix">
								<table class="table table_dashed" v-if="addLists.length>0">
									<tbody>
										<tr v-for="(addList,index) in addLists">
											<td>
												<span class="color_6">单套价格（人民币）：</span>
												<span class="color_9 addList_money" v-if="!costFlag">{{addList.money}} 元</span>
												<input type="text" class="form-control width_130 form_control addList_money" v-else :disabled="hidsubv" name="" maxlength="12" :id="'addList_money'+index" v-model="addList.money" /> 
											</td>
											<td>
												<span class="color_6">服务期限：</span>
												<span class="color_9 addList_timeLimit" v-if="!costFlag">{{addList.timeLimitValue}}</span>
												<input type="hidden" :id="'addList_timeLimit'+index" class="addList_timeLimit" :value="addList.timeLimit" />
												<!--<input type="text" class="form-control width_auto form_control" v-else name="" id="" :value="item.timeLimit" />-->
												<select class="form-control form_control width_130" v-model="addList.timeLimit" :disabled="hidsubv" v-if="costFlag">
													<option value="">请选择服务期限</option>
													<option value="1">1个月</option>
													<option value="12">1年</option>
													<option value="9999">无期限</option>
												</select>
											</td>
											<td>
												<span class="color_6">套数区间：</span>
												<span class="color_9 addList_minNum addList_maxNum" v-if="!costFlag">{{addList.minNum}} ~ {{addList.maxNum}} 套</span>
												<span class="suit" v-else>
													<input type="text" class="form-control form_control addList_minNum" name="" :disabled="hidsubv" :id="'addList_minNum'+index" maxlength="10" value="" v-model="addList.minNum"/>
													~
													<input type="text" class="form-control form_control addList_maxNum" name="" :disabled="hidsubv" :id="'addList_maxNum'+index" maxlength="10" value="" v-model="addList.maxNum"/>
												</span>
											</td>
											<td class="text-center" v-if="!hidsubv && !costFlag">
												<span class="btn_text" @click="costFlag = !costFlag">编辑</span>
											</td>
											<td class="text-center" v-if="!hidsubv">
												<span class="btn_text" @click="costDel(index)">删除</span>
											</td>
											<td :rowspan="addLists.length" v-if="index+1==1 && costFlag && !hidsubv" class="text-center">
												<span class="btn_text h4" @click="saveCharges">保存</span>
											</td>
										</tr>
									</tbody>
								</table>
							</section>
							
						</div>
					</div>
				</div>
			</section>
			<!--资费 end-->
			
			<!--免费试用 start-->
			<section class="authorization_box partition_message">
				<h4 class="message_title"><i class="must_color">*</i>免费试用</h4>
				<div class="authorization_container">
					<div class="container-fluid">
						<div class="row publick_form_box">

							<section class="form_box line_block">
								<label class="form_label" for="">免费试用：</label>
								<div class="radio_box">
									<input type="radio" class="radio_input_y" id="radio_charge1" name="radio_charge" :disabled="hidsubv" value="0" v-model="tCloudApp.freeType"/>
									<label class="form_label radio_label" for="radio_charge1">不支持</label>
								</div>
								<div class="radio_box">
									<input type="radio" class="radio_input_y " id="radio_charge2" name="radio_charge" :disabled="hidsubv" value="1" v-model="tCloudApp.freeType"/>
									<label class="form_label radio_label" for="radio_charge2">免费试用一个月</label>
								</div>
							</section>

						</div>
					</div>
				</div>
			</section>
			<!--免费试用 end-->

			<!--<p class="tip_sub_text partition_message text-center">
				内容已于
				<span>2016年12月2日 14:37分</span> 自动保存
			</p>-->
			<div class="btn_box text-center partition_message">
				<!--<span id="backBtn" class="btn">返回</span>-->
				<span id="save_app_btn" class="btn btn_submit" @click="doSubmit($event)">保存</span>
				<span id="inspect_app_btn" class="btn btn_submit" @click="doSubmit($event)" v-if="!hidsub">提交审核</span>
			</div>
		</div>

	</div>
</template>

<script>
	import { MessageBox } from 'element-ui'

	export default {
		name: 'issue_apply',
		data() {
			return {
				disabledFlag: false,
				classVisFlag: false,
				fileImg: '',
				falseFlag: false,
				bussiness: '',
				hid: false,
				hidsub: false,
				hidsubv: false,
				versioncontent: false,
				paths: [],
				value1: '',
				appTypeOptions: '',
				selected: '',
				appRange: '',
				appInterface: '',
				appAddServices: '',
				deployType: '',
				rangeCheck: [],
				interfaceCheck: [],
				addservicesCheck: [],
				images: [],
				imagesfile: '',
				icolist: [],
				appImage: [],
				appVersionList: [],
				appId: '',
				appVersionId: '',
				group_radio_range: [],
				inspertStatus: '',
				clientType: '',
				sFlag: false,
				clientTypeArray: [],
				webfileorignalname: '',
				tCloudApp: {
					id: '',
					appName: '',
					appEnName: '',
					appType: '',
					businessType: '',
					deployType: '',
					appClinetid: '',
					appClinetsercet: '',
					appversionid: '',
					uploadUser: '',
					specialType: '',
					delFlag: '',
					authCode: '',
					authType: '',
					inputTime: '',
					inputUser: '',
					updateTime: '',
					updateUser: '',
					viewName: '',
					freeType: '', //免费试用类型
					appLevel: '', //应用级别
				},
				tCloudAppVersion: {
					id: '',
					appid: '',
					versionNo: '',
					appComment: '',
					appInstallpackagePath: '',
					versionComment: '',
					publishTime: '',
					misdataApis: '',
					addserviceApis: '',
					visitUrl: '',
					userScope: '',
					inspectStatus: '',
					publishStatus: '',
					delFlag: '',
					inputTime: '',
					inputUser: '',
					updateTime: '',
					updateUser: '',
					publishType: '',
					appVersionIconFilePath: '',
					appVersionApplyFilePath: '',
					openType: '',
					windowWidth: '700',
					windowHeight: '500',
					clientType: ''
				},
				addList: {
					money: '',
					timeLimit: '请选择服务期限',
					timeLimitValue: '',//保存后的显示值
					minNum: '',
					maxNum: ''
				},
				addLists: [],
				costFlag: true,
			}//return
		},
		created: function() {
			//应用id
			this.appId = this.$route.params.appid;
			//应用id
			this.appVersionId = this.$route.params.appVersionId;
			//是否是第一个版本
			this.versioncontent = this.$route.params.versioncontent;
			this.inspertStatus = this.$route.params.inspertStatus;
			//查看应用信息
			this.getTCloudApp();
			this.getTCloudAppVersion();
			this.getSystemConfigList();
			this.getVersionFile();
			this.getHidStatus();
			//获取价格集合
			this.getPriceList();
		},
		computed: {

		},
		mounted: function() {
			this.$nextTick(function() {
				this.fileImg = require('../assets/images/ico-add.png');
				if(this.addLists.length <= 0){
					this.addOperation();
				}
			})
		},
		methods: {
			addOperation(){
				var temp = this;
				var newObj = {};
				newObj.money = "";
				newObj.timeLimit = "";
				newObj.minNum = "";
				newObj.maxNum = "";
				temp.addLists.push(newObj);
				temp.costFlag = true;
			},
			costDel(sub){
				this.addLists.splice(sub,1);
				if(this.addLists.length <= 0){
					this.addOperation();
				}
			},
			getSystemConfigList() {
				var temp = this;
				this.$http.post('/zklccloud/queryAllTCloudSysDictionary', {
					emulateJSON: true
				}).then(function(m) {
					for(var key in m.body.dictionaryMap) {
						if(key == '应用分类') {
							temp.appTypeOptions = m.body.dictionaryMap[key];
							if(null != temp.bussiness && '' != temp.bussiness) {
								temp.tCloudApp.businessType = temp.bussiness;
							}
						} else if(key == '群体范围') {
							temp.appRange = m.body.dictionaryMap[key];
						} else if(key == '增值服务') {
							temp.appAddServices = m.body.dictionaryMap[key];
						} else if(key == '数据接口权限') {
							temp.appInterface = m.body.dictionaryMap[key];
						} else if(key == '部署类型') {
							temp.deployType = m.body.dictionaryMap[key];
						} else if(key == '支持客户端') {
							temp.clientType = m.body.dictionaryMap[key];
						}
					}
				})
			},
			getTCloudApp() {
				var temp = this;
				if(null == temp.appId || '' == temp.appId) {
					return false;
				}
				this.$http.post('/zklccloud/findByAppid', {
					"appId": temp.appId
				}, {
					emulateJSON: true
				}).then(function(m) {
					if(m.body.resultCode == '0') {
						temp.tCloudApp = m.body.content.tCloudApp;
						if(temp.tCloudApp.authCode != '' && temp.tCloudApp.authCode != null) {
							$("#radio_authorization_form_box").slideDown();
						}
						temp.bussiness = m.body.content.tCloudApp.businessType;
						if(temp.tCloudApp.deployType == '109003')
						{
							$("#deploy_visitUrl").show();
							$("#package").hide();
						}
					} else {
						MessageBox('查询失败！', '提示', 'error', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
					}
				})
			},
			getTCloudAppVersion() {
				var temp = this;
				if(null == temp.appId || '' == temp.appId) {
					return false;
				}
				this.$http.post('/zklccloud/findTCloudAppVersionListById', {
					"appid": temp.appId
				}, {
					emulateJSON: true
				}).then(function(m) {
					temp.appVersionList = m.body.content.appVersionList
					for(var i = 0; i < m.body.content.appVersionList.length; i++) {
						if(temp.appVersionId == m.body.content.appVersionList[i].id) {
							temp.tCloudAppVersion = m.body.content.appVersionList[i];
							if(temp.tCloudAppVersion.appInstallpackagePath != null && temp.tCloudAppVersion.appInstallpackagePath != '') {
								$("#batchFile").parent().addClass("file_box_c");
							}
							if(this.tCloudAppVersion.publishType == '2') {
								$(".time_option").css("display", "inline-block");
							}
							temp.rangeCheck = temp.tCloudAppVersion.userScope.split(",");
							temp.interfaceCheck = temp.tCloudAppVersion.misdataApis.split(",");
							temp.addservicesCheck = temp.tCloudAppVersion.addserviceApis.split(",");
							temp.clientTypeArray = temp.tCloudAppVersion.clientType.split(",");
						}
					}
				})
			},
			getVersionFile() {
				var temp = this;
				if(null == temp.appId || '' == temp.appId) {
					return false;
				}
				this.$http.post('/zklccloud/findTCloudAppFilesByVersionId', {
					"appversionid": temp.appVersionId
				}, {
					emulateJSON: true
				}).then(function(m) {
					for(var i = 0; i < m.body.content.appFiles.length; i++) {
						if(m.body.content.appFiles[i].fileType == '108001') {
							temp.icolist.push(m.body.content.appFiles[i]);

							temp.fileImg = m.body.content.appFiles[0].filePath;
						} else {
							temp.paths.push(m.body.content.appFiles[i].filePath);
						}
					}
				})
			},
			getHidStatus() {
				var temp = this;
				if(null == temp.appId || '' == temp.appId) {
					return false;
				}
				this.$http.post('/zklccloud/findByVersionId', {
					"appversionId": temp.appVersionId
				}, {
					emulateJSON: true
				}).then(function(m) {
					temp.hid = m.body.content.hid;
					temp.hidsub = m.body.content.hidsub;
					temp.hidsubv = m.body.content.hidsubv;
				})
			},
			doSubmit(e) {
				e = e || window.event;
				var temp = this;
				this.tCloudAppVersion.userScope = this.rangeCheck.join(",");
				this.tCloudAppVersion.addserviceApis = this.addservicesCheck.join(",");
				this.tCloudAppVersion.misdataApis = this.interfaceCheck.join(",");
				var s = new Array;
				for(var i = 0; i < this.icolist.length; i++) {
					var icon = this.icolist[i];
					s.push(icon.viewSize + "-" + icon.filePath)
				}
				this.tCloudAppVersion.appVersionIconFilePath = s.join(",");
				this.tCloudAppVersion.appVersionApplyFilePath = this.paths.join(",");
				this.tCloudAppVersion.clientType = this.clientTypeArray.join(",");

				var name = $("#issue_applyName"),
					nameEn = $("#issue_applyEnName"),
					nameView = $("#issue_applyZName"),
					appNum = $("#issue_applyNumber"),
					issueSelect = $("#issue_select"),
					checkBox = $("#issue_checkbox"),

					checkBox1 = $("#issue_checkbox1"),

					checkBox2 = $("#issue_checkbox2"),
					dateBox = $("#issue_date_box");

				if($(e.target).html() == '保存') {
					this.tCloudAppVersion.inspectStatus = '9';
					if((/[^0-9\u4E00-\u9FA5]/g.test(name.val())) || '' == name.val()) {
						MessageBox('应用名称只允许中文及数字,限40个字符以内', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							name.focus();
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(/[^a-zA-Z0-9]/g.test(nameEn.val())) {
						MessageBox('英文名称最多输入60个字符，只允许英文和数字', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							nameEn.focus();
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if('' == nameView.val()) {
						MessageBox('显示在桌面的名称不能为空', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							nameView.focus();
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if((/[^a-z0-9.]/g).test(appNum.val())) {
						MessageBox('编号只允许小写英文和数字以及“.”,限20字符以内', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							appNum.focus();
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(this.tCloudAppVersion.publishType == '2' && ('' == this.tCloudAppVersion.publishTime || null == this.tCloudAppVersion.publishTime)) {
						MessageBox('请选择定时发布时间', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					}
					if(this.inspertStatus == '0') {
						if((/[^0-9\u4E00-\u9FA5]/g.test(name.val())) || '' == name.val()) {
							MessageBox('应用名称只允许中文及数字,限40个字符以内', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {
								name.focus();
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(/[^a-zA-Z0-9]/g.test(nameEn.val()) || '' == nameEn.val()) {
							MessageBox('英文名称最多输入60个字符，只允许英文和数字', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {
								nameEn.focus();
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if('' == nameView.val()) {
							MessageBox('显示在桌面的名称不能为空', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {
								nameView.focus();
							});
	
							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						}else if(/[^a-z0-9.]/g.test(appNum.val()) || '' == appNum.val()) {
							MessageBox('编号只允许小写英文和数字以及“.”,限20字符以内', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {
								appNum.focus();
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(issueSelect.find("option:selected").val() == "" || issueSelect.find("option:selected").val() == null) {
							MessageBox('请选择应用分类', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(checkBox.find("input[type='checkbox']:checked").length === 0) {
							MessageBox('群体范围项最少为一项', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(checkBox1.find("input[type='checkbox']:checked").length === 0) {
							MessageBox('增值服务项最少为一项', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(checkBox2.find("input[type='checkbox']:checked").length === 0) {
							MessageBox('数据接口权限项最少为一项', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(null == this.tCloudAppVersion.appComment || '' == this.tCloudAppVersion.appComment) {
							MessageBox('应用介绍不能为空', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(20 > this.tCloudAppVersion.appComment.length) {
							MessageBox('应用介绍描述字数小于20', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(this.tCloudApp.deployType == '109003' && (null == this.tCloudAppVersion.visitUrl || '' == this.tCloudAppVersion.visitUrl)) {
							MessageBox('请上传填写访问地址', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						}else if(this.tCloudApp.deployType != '109003' && (null == this.tCloudAppVersion.appInstallpackagePath || '' == this.tCloudAppVersion.appInstallpackagePath)) {
							MessageBox('请上传应用镜像包', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(this.versioncontent && (null == this.tCloudAppVersion.versionComment || '' == this.tCloudAppVersion.versionComment)) {
							MessageBox('版本介绍不能为空', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(this.versioncontent && (20 > this.tCloudAppVersion.versionComment.length)) {
							MessageBox('版本介绍描述字数小于20', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(null == this.tCloudAppVersion.publishType || '' == this.tCloudAppVersion.publishType) {
							MessageBox('请选择发布时间', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(this.tCloudAppVersion.publishType == '2' && ('' == this.tCloudAppVersion.publishTime || null == this.tCloudAppVersion.publishTime)) {
							MessageBox('请选择定时发布时间', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(null == this.tCloudAppVersion.appVersionIconFilePath || '' == this.tCloudAppVersion.appVersionIconFilePath) {
							MessageBox('请上传图标', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(null == this.tCloudAppVersion.appVersionApplyFilePath || '' == this.tCloudAppVersion.appVersionApplyFilePath) {
							MessageBox('请上传截图', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(this.paths.length < 2) {
							MessageBox('请上传多于2张的截图', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(null == this.tCloudApp.authType || '' == this.tCloudApp.authType) {
							MessageBox('请选择授权类型', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(null == this.tCloudApp.deployType || '' == this.tCloudApp.deployType) {
							MessageBox('请选择部署类型', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(null == this.tCloudAppVersion.openType || '' == this.tCloudAppVersion.openType) {
							MessageBox('请选择打开方式', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(this.tCloudAppVersion.openType == '2' && (null == this.tCloudAppVersion.windowWidth || '' == this.tCloudAppVersion.windowWidth)) {
							MessageBox('请输入宽度', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(this.tCloudAppVersion.openType == '2' && (null == this.tCloudAppVersion.windowHeight || '' == this.tCloudAppVersion.windowHeight)) {
							MessageBox('请输入高度', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(null == this.tCloudAppVersion.clientType || '' == this.tCloudAppVersion.clientType) {
							MessageBox('请选择支持客户端', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						} else if(null == this.tCloudApp.freeType || '' == this.tCloudApp.freeType) {
							MessageBox('请选择是否支持试用', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						}
					}
					if(temp.costFlag){
						var addList_money = $(".addList_money"),
						addList_minNum = $(".addList_minNum"),
						addList_maxNum = $(".addList_maxNum"),
						addList_timeLimit = $(".addList_timeLimit"),
						arrays = [],
						tpList = [];
						var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
						var regx = /^[0-9]*[1-9][0-9]*$/;
						for(var i=0; i<addList_money.length; i++){
							temp.addList = {};
							if(!reg.test($(addList_money[i]).val())){
								MessageBox('请输入正确的单套价格！', '提示', 'warning', {
									confirmButtonText: '确定',
								}).then(() => {
									$("#addList_money"+i).focus();
								});
								return false;
							}
							if($(addList_timeLimit[i]).val() == ''){
								MessageBox('请选择服务期限！', '提示', 'warning', {
									confirmButtonText: '确定',
								}).then(() => {
									$("#addList_timeLimit"+i).focus();
								})
								return false;
							}
							if(!regx.test($(addList_minNum[i]).val())){
								MessageBox('套数上限只允许正整数！', '提示', 'warning', {
									confirmButtonText: '确定',
								}).then(() => {
									$("#addList_minNum"+i).focus();
								})
								return false;
							}
							if(!regx.test($(addList_maxNum[i]).val())){
								MessageBox('套数下限只允许正整数！', '提示', 'warning', {
									confirmButtonText: '确定',
								}).then(() => {
									$("#addList_maxNum"+i).focus();
								})
								return false;
							}
							if($(addList_maxNum[i]).val() - $(addList_minNum[i]).val() < 0){
								MessageBox('非法数据，请重新输入！', '提示', 'warning', {
									confirmButtonText: '确定',
								}).then(() => {
									$("#addList_maxNum"+i).focus();
								})
								return false;
							}
//							if(i != 0 && $(addList_minNum[i]).val() - $(addList_maxNum[i-1]).val() != 1){
//								MessageBox('请按顺序输入套数，如：1~1;2~10;11~20', '提示', 'warning', {
//									confirmButtonText: '确定',
//								}).then(() => {
//									$("#addList_minNum"+i).focus();
//								})
//								return false;
//							}
							
							tpList.push($(addList_timeLimit[i]).val()+":"+$(addList_minNum[i]).val()+":"+$(addList_maxNum[i]).val());
							
							temp.addList.money = $(addList_money[i]).val();
							temp.addList.timeLimit = $(addList_timeLimit[i]).val();
							temp.addList.minNum = $(addList_minNum[i]).val();
							temp.addList.maxNum = $(addList_maxNum[i]).val();
							arrays.push(temp.addList);
						}
						temp.validateArray(tpList);
						temp.addLists = [];
						temp.addLists = arrays;
						if(temp.validateArray(tpList)){
							temp.costFlag = false;
						}else{
							return false;
						}
					}
					
					var formData = JSON.stringify(temp.addLists);
				} else {
					this.tCloudAppVersion.inspectStatus = '0';
					if((/[^0-9\u4E00-\u9FA5]/g.test(name.val())) || '' == name.val()) {
						MessageBox('应用名称只允许中文及数字,限40个字符以内', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							name.focus()
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(/[^a-zA-Z0-9]/g.test(nameEn.val()) || '' == nameEn.val()) {
						MessageBox('英文名称最多输入60个字符，只允许英文和数字', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							nameEn.focus()
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if('' == nameView.val()) {
						MessageBox('显示在桌面的名称不能为空', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							nameView.focus();
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					}else if(/[^a-z0-9.]/g.test(appNum.val()) || '' == appNum.val()) {
						MessageBox('编号只允许小写英文和数字以及“.”,限20字符以内', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							appNum.focus()
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(issueSelect.find("option:selected").val() == "" || issueSelect.find("option:selected").val() == null) {
						MessageBox('请选择应用分类', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(null == this.tCloudApp.appLevel || '' == this.tCloudApp.appLevel) {
							MessageBox('请选择应用范围', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
					} else if(checkBox.find("input[type='checkbox']:checked").length === 0) {
						MessageBox('群体范围项最少为一项', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(checkBox1.find("input[type='checkbox']:checked").length === 0) {
						MessageBox('增值服务项最少为一项', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(checkBox2.find("input[type='checkbox']:checked").length === 0) {
						MessageBox('数据接口权限项最少为一项', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(null == this.tCloudAppVersion.appComment || '' == this.tCloudAppVersion.appComment) {
						MessageBox('应用介绍不能为空', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(20 > this.tCloudAppVersion.appComment.length) {
						MessageBox('应用介绍描述字数小于20', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(this.tCloudApp.deployType == '109003' && (null == this.tCloudAppVersion.visitUrl || '' == this.tCloudAppVersion.visitUrl)) {
							MessageBox('请上传填写访问地址', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
						}else if(this.tCloudApp.deployType != '109003' && (null == this.tCloudAppVersion.appInstallpackagePath || '' == this.tCloudAppVersion.appInstallpackagePath)) {
						MessageBox('请上传应用镜像包', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(this.versioncontent && (null == this.tCloudAppVersion.versionComment || '' == this.tCloudAppVersion.versionComment)) {
						MessageBox('版本介绍不能为空', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(this.versioncontent && (20 > this.tCloudAppVersion.versionComment.length)) {
						MessageBox('版本介绍描述字数小于20', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(null == this.tCloudAppVersion.publishType || '' == this.tCloudAppVersion.publishType) {
						MessageBox('请选择发布时间', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(this.tCloudAppVersion.publishType == '2' && ('' == this.tCloudAppVersion.publishTime || null == this.tCloudAppVersion.publishTime)) {
						MessageBox('请选择定时发布时间', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(null == this.tCloudAppVersion.appVersionIconFilePath || '' == this.tCloudAppVersion.appVersionIconFilePath) {
						MessageBox('请上传图标', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(null == this.tCloudAppVersion.appVersionApplyFilePath || '' == this.tCloudAppVersion.appVersionApplyFilePath) {
						MessageBox('请上传截图', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(this.paths.length < 2) {
						MessageBox('请上传多于2张的截图', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(null == this.tCloudApp.authType || '' == this.tCloudApp.authType) {
						MessageBox('请选择授权类型', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(null == this.tCloudApp.deployType || '' == this.tCloudApp.deployType) {
						MessageBox('请选择部署类型', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(null == this.tCloudAppVersion.openType || '' == this.tCloudAppVersion.openType) {
						MessageBox('请选择打开方式', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(this.tCloudAppVersion.openType == '2' && (null == this.tCloudAppVersion.windowWidth || '' == this.tCloudAppVersion.windowWidth)) {
						MessageBox('请输入宽度', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(this.tCloudAppVersion.openType == '2' && (null == this.tCloudAppVersion.windowHeight || '' == this.tCloudAppVersion.windowHeight)) {
						MessageBox('请输入高度', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(null == this.tCloudAppVersion.clientType || '' == this.tCloudAppVersion.clientType) {
						MessageBox('请选择支持客户端', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else if(null == this.tCloudApp.freeType || '' == this.tCloudApp.freeType) {
							MessageBox('请选择是否支持试用', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
							return false;
					}
					if(temp.costFlag){
						var addList_money = $(".addList_money"),
						addList_minNum = $(".addList_minNum"),
						addList_maxNum = $(".addList_maxNum"),
						addList_timeLimit = $(".addList_timeLimit"),
						arrays = [],
						tpList = [];
						var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
						var regx = /^[0-9]*[1-9][0-9]*$/;
						for(var i=0; i<addList_money.length; i++){
							temp.addList = {};
	
							if(!reg.test($(addList_money[i]).val())){
								MessageBox('请输入正确的单套价格！', '提示', 'warning', {
									confirmButtonText: '确定',
								}).then(() => {
									$("#addList_money"+i).focus();
								});
								return false;
							}
							if($(addList_timeLimit[i]).val() == ''){
								MessageBox('请选择服务期限！', '提示', 'warning', {
									confirmButtonText: '确定',
								}).then(() => {
									$("#addList_timeLimit"+i).focus();
								})
								return false;
							}
							if(!regx.test($(addList_minNum[i]).val())){
								MessageBox('套数上限只允许正整数！', '提示', 'warning', {
									confirmButtonText: '确定',
								}).then(() => {
									$("#addList_minNum"+i).focus();
								})
								return false;
							}
							if(!regx.test($(addList_maxNum[i]).val())){
								MessageBox('套数下限只允许正整数！', '提示', 'warning', {
									confirmButtonText: '确定',
								}).then(() => {
									$("#addList_maxNum"+i).focus();
								})
								return false;
							}
							if($(addList_maxNum[i]).val() - $(addList_minNum[i]).val() < 0){
								MessageBox('非法数据，请重新输入！', '提示', 'warning', {
									confirmButtonText: '确定',
								}).then(() => {
									$("#addList_maxNum"+i).focus();
								})
								return false;
							}
//							if(i != 0 && $(addList_minNum[i]).val() - $(addList_maxNum[i-1]).val() != 1){
//								MessageBox('请按顺序输入套数，如：1~1;2~10;11~20', '提示', 'warning', {
//									confirmButtonText: '确定',
//								}).then(() => {
//									$("#addList_minNum"+i).focus();
//								})
//								return false;
//							}
							
							tpList.push($(addList_timeLimit[i]).val()+":"+$(addList_minNum[i]).val()+":"+$(addList_maxNum[i]).val());
							
							temp.addList.money = $(addList_money[i]).val();
							temp.addList.timeLimit = $(addList_timeLimit[i]).val();
							temp.addList.minNum = $(addList_minNum[i]).val();
							temp.addList.maxNum = $(addList_maxNum[i]).val();
							arrays.push(temp.addList);
						}
						temp.validateArray(tpList);
						temp.addLists = [];
						temp.addLists = arrays;
						if(temp.validateArray(tpList)){
							temp.costFlag = false;
						}else{
							return false;
						}
					}
					
					var formData = JSON.stringify(temp.addLists);
				}
				var parameter = {
					"tcloudapp": this.tCloudApp,
					"tcloudappversion": this.tCloudAppVersion,
					"jsonStr": formData
				};
				this.$http.post('/zklccloud/saveTCloudApp', JSON.stringify(parameter), {emulateJSON: true}).then(function(data) {
					if(data.body.resultCode == '0') {
						MessageBox('操作成功', '提示', 'success', {
							confirmButtonText: '确定',
						}).then(() => {
							temp.$router.push({
								path: '/all_app'
							});
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
					} else if(data.body.resultCode == 'exit') {
						//						temp.falseFlag = true;
						//						temp.tipMsg = "操作失败";
						MessageBox('应用名称已存在', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					} else {
						MessageBox('操作失败', '提示', 'error', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						return false;
					}
				}).catch(function() {
					//					    temp.falseFlag = true;
					//						temp.tipMsg = "服务器异常";
					MessageBox('服务器异常', '提示', 'error', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
				});

			},
			uploadImage: function(e) {
				e = e || window.event;
				var temp = this;
				$("#subform").ajaxSubmit(function(data) {
					if(data.resultCode == '0') {
						MessageBox('操作成功！', '提示', 'success', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
						temp.icolist = [];
						temp.icolist = data.content.filepath;
						temp.fileImg = temp.icolist[0].filePath;
						temp.classVisFlag = false;
					} else {
						temp.classVisFlag = false;
						if(data.content.filepath == "#nottype#") {
							MessageBox('操作失败，请检查附件大小和类型！', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
						} else {
							MessageBox('操作失败，请上传等边矩形且尺寸>=512的图片！', '提示', 'warning', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
						}
					}
				});
			},
			addAppImage: function(e) {
				e = e || window.event;
				var temp = this;
				var fileObj = e.target.files || e.dataTransfer.files; // js 获取文件对象
				var FileController = '/zklccloud/uploadImages'; // 接收上传文件的后台地址 
				// FormData 对象
				var form = new FormData();
				form.append("file", fileObj[0]); // 文件对象
				form.append("type", "1");
				var xhr = new XMLHttpRequest();
				xhr.open("post", FileController, true);
				xhr.onload = function() {
					var ttt = eval('(' + xhr.responseText + ')');
					if(ttt.resultCode == '0') {
						temp.paths.push(ttt.content.filepath);
					} else {
						MessageBox('操作失败，请检查附件大小和类型！', '提示', 'warning', {
							confirmButtonText: '确定',
						});

						if($(".el-message-box__btns")) {
							$(".el-message-box__btns").attr("id", "btnSub");
						}
					}
				};
				xhr.send(form);
			},
			uploadWeb: function(e) {
				e = e || window.event;
				// 进度条归零发
				$("#progressBar").width("0%");
				// 上传按钮禁用
				$("#uploadBtn").attr("disabled", true);
				// 进度条显示
				$("#progressBar").parent().show();
				$("#progressBar").parent().addClass("active");
				var files = e.target.files || e.dataTransfer.files;
				this.upload(e);
			},
			upload: function(e) {
				e = e || window.event;
				var temp = this;
				var fileObj = $("#batchFile").get(0).files[0]; // js 获取文件对象
				var FileController = '/zklccloud/upload?dat=' + new Date().getTime(); // 接收上传文件的后台地址 
				// FormData 对象
				var form = new FormData();
				form.append("file", fileObj); // 文件对象
				form.append("access_token",localStorage.getItem('token'));
				// XMLHttpRequest 对象
				var xhr = new XMLHttpRequest();
				xhr.open("post", FileController, true);
				xhr.onload = function() {
					// ShowSuccess("上传完成");
					var ttt = eval('(' + xhr.responseText + ')');
					MessageBox('上传完成！', '提示', 'success', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					$("#batchUploadBtn").attr('disabled', false);
					$("#batchUploadBtn").val("上传");
					$("#batchFile").parent().addClass("file_box_c");

					$("#progressBar").parent().removeClass("active");
					$("#progressBar").parent().hide();
					$("#batchFile").attr("disabled", true);
					temp.tCloudAppVersion.appInstallpackagePath = ttt.content.filepath;
					temp.webfileorignalname = ttt.content.originalFilename;
				};
				xhr.upload.addEventListener("progress", this.progressFunction, false);
				xhr.send(form);
			},
			progressFunction: function(evt) {
				var progressBar = $("#progressBar");
				if(evt.lengthComputable) {
					var completePercent = Math.round(evt.loaded / evt.total * 100) + "%";
					progressBar.width(completePercent);
					$("#batchUploadBtn").val("正在上传 " + completePercent);
				}
			},
			valdata: function(e) {
				e = e || window.event;
				if($(e.target).val().length < 20) {
					MessageBox('20到500个字符', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if($(e.target).val().length > 500) {
					MessageBox('20到500个字符', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					this.tCloudAppVersion.appComment = $(e.target).val().substring(0, 500);
					return false;
				}
			},
			valdata1: function(e) {
				e = e || window.event;
				if($(e.target).val().length < 20) {
					MessageBox('20到500个字符', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					return false;
				} else if($(e.target).val().length > 500) {
					MessageBox('20到500个字符', '提示', 'warning', {
						confirmButtonText: '确定',
					});

					if($(".el-message-box__btns")) {
						$(".el-message-box__btns").attr("id", "btnSub");
					}
					this.tCloudAppVersion.versionComment = $(e.target).val().substring(0, 500);
					return false;
				}
			},
			authorizationBoxShow: function(e) {
				var temp = this;

				if(this.tCloudApp.authType == '2') {
					$("#radio_authorization_form_box").show()
					this.$http.post('/zklccloud/queryAuthCode', {
						emulateJSON: true
					}).then(function(m) {
						if(m.body.resultCode == '0') {
							temp.tCloudApp.authCode = m.body.content.authCode;
						} else {
							MessageBox('查询失败！', '提示', 'error', {
								confirmButtonText: '确定',
							});

							if($(".el-message-box__btns")) {
								$(".el-message-box__btns").attr("id", "btnSub");
							}
						}
					})
				} else {
					temp.tCloudApp.authCode = '';
					$("#radio_authorization_form_box").hide()
				}
			},
			openSub: function(type) {
				this.tCloudAppVersion.publishType = type;
				if(type == '2') {
					$(".time_option").css("display", "inline-block");
				} else {
					this.tCloudAppVersion.publishTime = '';
					$(".time_option").css("display", "none");
				}
			},
			delImg: function(index) {
				this.paths.splice(index, 1)
			},
			delPackage: function(e) {
				$(e.target).siblings(".file_box").removeClass("file_box_c");
				$("#batchFile").attr("disabled", false);
				this.tCloudAppVersion.appInstallpackagePath = '';
			},
			newwindow: function(e) {
				this.tCloudAppVersion.windowWidth = '';
				this.tCloudAppVersion.windowHeight = '';
			},
			newwindow1: function(e) {
				if(this.tCloudAppVersion.windowWidth == "" || this.tCloudAppVersion.windowHeight == "") {
					this.tCloudAppVersion.windowWidth = '700';
					this.tCloudAppVersion.windowHeight = '500';
				}
			},
			disabledF() {
				this.classVisFlag = true;
				var temp = this;
				setTimeout(function() {
					temp.classVisFlag = false;
				}, 2000)
			},
			showVistUrl(code){
				if(code == '109003')
				{
					$("#deploy_visitUrl").show();
					$("#package").hide();
					this.tCloudAppVersion.appInstallpackagePath = '';
				}
				else{
					$("#deploy_visitUrl").hide();
					$("#package").show();
					this.tCloudAppVersion.visitUrl = '';
				}
			},
			//保存资费
			saveCharges(){
				var temp = this;
				var addList_money = $(".addList_money"),
					addList_minNum = $(".addList_minNum"),
					addList_maxNum = $(".addList_maxNum"),
					addList_timeLimit = $(".addList_timeLimit"),
					arrays = [],
					tempList = [];
					var reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
					var regx = /^[0-9]*[1-9][0-9]*$/;
					for(var i=0; i<addList_money.length; i++){
						temp.addList = {};
						
						if(!regx.test($(addList_money[i]).val())){
							MessageBox('请输入正确的单套价格！', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {
								$("#addList_money"+i).focus();
							});
							return false;
						}
						if($(addList_timeLimit[i]).val() == ''){
							MessageBox('请选择服务期限！', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {
								$("#addList_timeLimit"+i).focus();
							})
							return false;
						}
						if(!regx.test($(addList_minNum[i]).val())){
							MessageBox('套数上限只允许正整数！', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {
								$("#addList_minNum"+i).focus();
							})
							return false;
						}
						if(!regx.test($(addList_maxNum[i]).val())){
							MessageBox('套数下限只允许正整数！', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {
								$("#addList_maxNum"+i).focus();
							})
							return false;
						}
						if($(addList_maxNum[i]).val() - $(addList_minNum[i]).val() < 0){
							MessageBox('非法数据，请重新输入！', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {
								$("#addList_maxNum"+i).focus();
							})
							return false;
						}
//						if(i != 0 && $(addList_timeLimit[i]).val() == 1 && $(addList_timeLimit[i-1]).val() == 1 && $(addList_minNum[i]).val() - $(addList_maxNum[i-1]).val() != 1){
//							MessageBox('请按顺序输入套数，如：1~1;2~10;11~20', '提示', 'warning', {
//								confirmButtonText: '确定',
//							}).then(() => {
//								$("#addList_minNum"+i).focus();
//							})
//							return false;
//						}else if(i != 0 && $(addList_timeLimit[i]).val() == 12 && $(addList_timeLimit[i-1]).val() == 12 && $(addList_minNum[i]).val() - $(addList_maxNum[i-1]).val() != 1){
//							MessageBox('请按顺序输入套数，如：1~1;2~10;11~20', '提示', 'warning', {
//								confirmButtonText: '确定',
//							}).then(() => {
//								$("#addList_minNum"+i).focus();
//							})
//							return false;
//						}else if(i != 0 && $(addList_timeLimit[i]).val() == 9999 && $(addList_timeLimit[i-1]).val() == 9999 && $(addList_minNum[i]).val() - $(addList_maxNum[i-1]).val() != 1){
//							MessageBox('请按顺序输入套数，如：1~1;2~10;11~20', '提示', 'warning', {
//								confirmButtonText: '确定',
//							}).then(() => {
//								$("#addList_minNum"+i).focus();
//							})
//							return false;
//						}
						
						tempList.push($(addList_timeLimit[i]).val()+":"+$(addList_minNum[i]).val()+":"+$(addList_maxNum[i]).val());
						
						if($(addList_timeLimit[i]).val() == 1){
							temp.addList.timeLimitValue = '1个月'
						}else if($(addList_timeLimit[i]).val() == 12){
							temp.addList.timeLimitValue = '1年'
						}else if($(addList_timeLimit[i]).val() == 9999){
							temp.addList.timeLimitValue = '无期限'
						}
						
						temp.addList.money = $(addList_money[i]).val();
						temp.addList.timeLimit = $(addList_timeLimit[i]).val();
						temp.addList.minNum = $(addList_minNum[i]).val();
						temp.addList.maxNum = $(addList_maxNum[i]).val();
						arrays.push(temp.addList);
					}
					temp.validateArray(tempList);
					temp.addLists = arrays;
					if(temp.validateArray(tempList)){
						temp.costFlag = false;
					}else{
						return false;
					}
			},
			validateArray(arr){//数组去重
			  var result=[];
			  var newArrays1=[];var newArrays12=[];var newArrays9999=[];
			  for(var i=0; i<arr.length; i++){
			  	if(arr[i].split(":")[0] == 1){
			  		newArrays1.push(arr[i].split(":")[1]+":"+arr[i].split(":")[2]);
			  	}else if(arr[i].split(":")[0] == 12){
			  		newArrays12.push(arr[i].split(":")[1]+":"+arr[i].split(":")[2]);
			  	}else if(arr[i].split(":")[0] == 9999){
			  		newArrays9999.push(arr[i].split(":")[1]+":"+arr[i].split(":")[2]);
			  	}
			  	
			  	for(var k=0; k<newArrays1.length; k++){
			  		if(k>0 && newArrays1[k].split(":")[0] - newArrays1[k-1].split(":")[1] != 1){
			  			MessageBox('请按顺序输入套数，如：1~1;2~10;11~20', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {
								
							})
							return false;
			  		}
			  	}
			  	
			  	for(var m=0; m<newArrays12.length; m++){
			  		if(m>0 && newArrays12[m].split(":")[0] - newArrays12[m-1].split(":")[1] != 1){
			  			MessageBox('请按顺序输入套数，如：1~1;2~10;11~20', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {
								
							})
							return false;
			  		}
			  	}
			  	
			  	for(var n=0; n<newArrays9999.length; n++){
			  		if(n>0 && newArrays9999[n].split(":")[0] - newArrays9999[n-1].split(":")[1] != 1){
			  			MessageBox('请按顺序输入套数，如：1~1;2~10;11~20', '提示', 'warning', {
								confirmButtonText: '确定',
							}).then(() => {
								
							})
							return false;
			  		}
			  	}
			  	
			    if(result.indexOf(arr[i])==-1){
			      result.push(arr[i])
			    }else{
			    	MessageBox('数据重复，请重新输入', '提示', 'warning', {
							confirmButtonText: '确定',
						}).then(() => {
							
						});
						return false;
			    }
			  }
			 return result;
			},
			getPriceList(){
				var temp = this;
				if(null == temp.appId || '' == temp.appId || 'undefined' == temp.appId) {
					return false;
				}
				this.$http.post('/zklccloud/findPriceListByAppId', {
					"appId": temp.appId
				}, {
					emulateJSON: true
				}).then(function(m) {
					if(m.body.resultCode == '0') {
						if('' == m.body.content.priceList){
							temp.addLists = [];
							temp.addOperation();
						}else{
							temp.costFlag = false;
							temp.addLists = m.body.content.priceList;
						}
					}
				})
			}
		},
	}
</script>

<style scoped>
	.width_140 {
		width: 140px!important;
	}
	.width_130 {
		width: 130px!important;
	}
	.btn_border {
		height: 34px;
		-webkit-border-radius: 2px;
		-moz-border-radius: 2px;
		border-radius: 2px;
	}
	.add_operation .form_control {
		width: 118px;
	}
	.add_operation  {
		margin-bottom: 15px;
	}
	.suit {
		display: inline-block;
		width: 140px;
	}
	.suit .form_control {
		width: 60px;
	}
	.margin_l15 {
		margin-left: 15px;
	}
	.table_dashed td {
		border: 1px dashed #ccc;
	}
	
	.add_list .left {
	}
	
	.add_list .left .table {
		margin-bottom: 0;
	}
	
	.btn_box {
		margin-bottom: 15px;
	}
	
</style>


// WEBPACK FOOTER //
// add_app.vue?66f433fe